<template>
  <b-overlay>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col
              cols="4"
              v-for="item in courseTypes"
              :key="item.courseTypeId"
            >
              <b-card
                style="cursor: pointer"
                :border-variant="isCourseTypeSelected(item.courseTypeId)"
                :title="item.title"
                @click="setCourseTypeId(item.courseTypeId)"
              >
                <b-card-text>
                  {{ item.title }}
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="4" v-for="course in courseList" :key="course.courseId">
              <b-card
                @click="setSelectedCourse(course.courseId)"
                :title="course.title"
                style="cursor: pointer"
                :border-variant="isCourseSelected(course.courseId)"
              >
                {{ course.title }}
              </b-card>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col
              cols="4"
              v-for="lesson in lessonsList"
              :key="lesson.lessonId"
            >
              {{ lesson.title }}
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { GetCourseTypes } from "../../../libs/Api/CourseType";
import { GetAllCourses } from "../../../libs/Api/Course";
import { GetAllLessonsOfCourse } from "../../../libs/Api/Lesson";
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
export default {
  mounted() {
    this.getAllCourseTypes();
  },
  data() {
    return {
      courseTypes: null,
      selectedCourseType: null,
      courseList: null,
      selectedCourse: null,
      lessonsList: null,
    };
  },
  methods: {
    async getAllLessonsOfSelectedCourse() {
      let _this = this;
      let getAllLessonsOfCourse = new GetAllLessonsOfCourse(_this);
      getAllLessonsOfCourse.setRequestParam({
        count: 0,
        pageNumber: 0,
        courseId: _this.selectedCourse,
      });
      await getAllLessonsOfCourse.fetch(
        function (response) {
          _this.lessonsList = response.lessons;
        },
        function (error) {
          console.error(error);
        }
      );
    },
    setSelectedCourse(courseId) {
      if (this.selectedCourse != courseId) {
        this.selectedCourse = courseId;
        this.getAllLessonsOfSelectedCourse();
      }
    },
    isCourseSelected(courseId) {
      if (this.selectedCourse && this.selectedCourse == courseId) {
        return "success";
      } else {
        return "black";
      }
    },
    isCourseTypeSelected(courseTypeId) {
      if (this.selectedCourseType && this.selectedCourseType == courseTypeId) {
        return "success";
      } else {
        return "black";
      }
    },
    setCourseTypeId(courseTypeId) {
      if (this.selectedCourseType != courseTypeId) {
        this.selectedCourseType = courseTypeId;
        this.getAllCourses();
      }
    },
    async getAllCourses() {
      let _this = this;
      let getAllCourses = new GetAllCourses(_this);
      getAllCourses.setRequestParam({
        count: 0,
        pageNumber: 0,
        courseTypeId: _this.selectedCourseType,
      });
      await getAllCourses.fetch(
        function (response) {
          _this.courseList = response.courses;
          console.log(_this.courseList);
        },
        function (error) {
          console.error(error);
        }
      );
    },
    async getAllCourseTypes() {
      let _this = this;
      let getCourseTypes = new GetCourseTypes(_this);
      getCourseTypes.setParams({
        count: 0,
        pageNumber: 0,
      });
      await getCourseTypes.fetch(
        function (response) {
          _this.courseTypes = response.courseTypes;
        },
        function (error) {
          console.error(error);
        }
      );
    },
  },
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BForm,
    BFormRadio,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
  },
};
</script>
